import { render, staticRenderFns } from "./alist.vue?vue&type=template&id=31853fdd"
import script from "./alist.vue?vue&type=script&lang=js"
export * from "./alist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports